/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* HGH mobile launcher stacking: keep Shopify chat above the HGH Club launcher. */
(function() {
  if (document.getElementById('hgh-mobile-launcher-stack-styles')) return;

  var style = document.createElement('style');
  style.id = 'hgh-mobile-launcher-stack-styles';
  style.textContent =
    '@media screen and (max-width: 767px) {' +
      '#dummy-chat-button-iframe,#shopify-chat > iframe{' +
        'bottom:86px !important;' +
        'right:12px !important;' +
        'z-index:10020 !important;' +
      '}' +
      '#shopify-chat{' +
        'bottom:0 !important;' +
        'z-index:10020 !important;' +
      '}' +
      '#shopify-chat > iframe[isOpen="true"],' +
      '#shopify-chat > iframe[style*="min-height"],' +
      '#shopify-chat > iframe[style*="left: 0"]{' +
        'bottom:100px !important;' +
        'right:0 !important;' +
        'z-index:10020 !important;' +
      '}' +
    '}';

  document.head.appendChild(style);
})();